export const addAuthHeaders = (headers) => {
    headers.append("x-csrf-token", Liferay.authToken);
    // For local development only
    if (typeof Liferay.authToken === 'undefined') {
        // Rafal
        //headers.append("Authorization", "Basic cG9ydGFsLmFkbWluQHVwMmQ1LmRlOnRlc3QxMjM=")
        // Tom
        headers.append("Authorization", "Basic cG9ydGFsLmFkbWluQHVwMmQ1LmRlOnRlc3Q=")
    }
}
export async function fetchCartsData(page, query) {
    const headers = new Headers();
    addAuthHeaders(headers)
    const accountId = window.Liferay.CommerceContext.account.accountId;
    const commerceChannelId = window.Liferay.CommerceContext.commerceChannelId;
    const requestOptions = {
        method: "GET",
        headers: headers,
        redirect: "follow"
    };
    return Liferay.Util.fetch(`/o/up2date-commerce-delivery-cart/carts/channels/${commerceChannelId}/account/${accountId}?page=${page}&pageSize=10&search=${query}`,
        requestOptions);
}
export async function fetchCurrentCartData() {
    const headers = new Headers();
    addAuthHeaders(headers)
    const accountId = window.Liferay.CommerceContext.account.accountId;
    const commerceChannelId = window.Liferay.CommerceContext.commerceChannelId;
    const requestOptions = {
        method: "GET",
        headers: headers,
        redirect: "follow"
    };
    const currentCartResponse = await Liferay.Util.fetch(`/o/up2date-commerce-delivery-cart/carts/channels/${commerceChannelId}/account/${accountId}/current-cart`,
        requestOptions);
    if(currentCartResponse.status === 200) {
        return currentCartResponse.json();
    }
    if(currentCartResponse.status === 404) {
        return null;
    }
    throw new Error("")
}
export async function deleteCart(cartId) {
    const headers = new Headers();
    addAuthHeaders(headers)
    const requestOptions = {
        method: "DELETE",
        headers: headers,
        redirect: "follow"
    };
    return Liferay.Util.fetch(`/o/headless-commerce-delivery-cart/v1.0/carts/${cartId}`,
        requestOptions);
}
export async function addCart(name, insuranceId, insuranceCaseNumber) {
    const headers = new Headers();
    headers.append("Content-Type", "application/json")
    addAuthHeaders(headers)
    let accountId = `${window.Liferay.CommerceContext.account.accountId}`;
    let currencyCode = window.Liferay.CommerceContext.currency.currencyCode;
    const body = {
        accountId, currencyCode,
        customFields: {
            "cartCustomName": name,
            "insurance": insuranceId,
            "insuranceCaseNumber": insuranceCaseNumber
        }
    }
    const requestOptions = {
        method: "POST",
        headers: headers,
        redirect: "follow",
        body : JSON.stringify(body)
    };
    const commerceChannelId = window.Liferay.CommerceContext.commerceChannelId;
    const addToCartResponse = await Liferay.Util.fetch(`/o/headless-commerce-delivery-cart/v1.0/channels/${commerceChannelId}/carts`,
        requestOptions);
    if(addToCartResponse.status !== 200) {
        throw new Error("");
    }
    const addToCartResponseJson = await addToCartResponse.json();
    await selectCart(addToCartResponseJson.id);
    return addToCartResponseJson;
}
export async function updateCart(order) {
    const headers = new Headers();
    headers.append("Content-Type", "application/json")
    addAuthHeaders(headers);
    const requestOptions = {
        method: "PATCH",
        headers: headers,
        redirect: "follow",
        body : JSON.stringify(order)
    };
    return Liferay.Util.fetch(`/o/headless-commerce-delivery-cart/v1.0/carts/${order.id}`,
        requestOptions);
}
export async function selectCart(orderId) {
    const headers = new Headers();
    addAuthHeaders(headers);
    const requestOptions = {
        method: "POST",
        headers: headers,
        redirect: "follow"
    };
    const response = await Liferay.Util.fetch(`/o/up2date-commerce-delivery-cart/carts/current/${orderId}`,
        requestOptions);
    if(response.status === 200) {
        return response;
    } else {
        throw new Error("");
    }
}
export async function getInsurances() {
    const headers = new Headers();
    addAuthHeaders(headers);
    const accountId = window.Liferay.CommerceContext.account.accountId;
    const requestOptions = {
        method: "GET",
        headers: headers,
        redirect: "follow"
    };
    const response = await Liferay.Util.fetch(`/o/insurance-clubs/insurances/${accountId}`, requestOptions);
    if(response.status === 200) {
        return response.json();
    } else {
        throw new Error("");
    }
}

export async function getInsuranceCarts(insuranceId, accountId) {
    if(insuranceId === 0 || insuranceId === '0') {
        return [];
    }
    const headers = new Headers();
    addAuthHeaders(headers);
    const requestOptions = {
        method: "GET",
        headers: headers,
        redirect: "follow"
    };
    const response = await Liferay.Util.fetch(`/o/shared-rest-api/v1.0/carts/insurance/${insuranceId}`, requestOptions);
    if(response.status === 200) {
        if(accountId) {
            let json = await response.json();
            let currentAccountIdCarts = json.extendedCart.filter(extendedCart => extendedCart?.cart?.accountId === accountId);
            return Promise.resolve({
                extendedCart: currentAccountIdCarts
            });
        } else {
            return response.json();
        }
    } else {
        throw new Error("");
    }
}